const FREE_MENU_IMAGES = [
  "https://images.unsplash.com/photo-1565557623262-b51c2513a641?auto=format&fit=crop&w=700&q=80",
  "https://images.unsplash.com/photo-1631515242808-497c3fbd3972?auto=format&fit=crop&w=700&q=80",
  "https://images.unsplash.com/photo-1697155406055-2db32d47ca07?auto=format&fit=crop&w=700&q=80",
  "https://images.unsplash.com/photo-1601050690597-df0568f70950?auto=format&fit=crop&w=700&q=80",
  "https://images.unsplash.com/photo-1728910156510-77488f19b152?auto=format&fit=crop&w=700&q=80",
  "https://images.unsplash.com/photo-1536305030588-45dc07a2a372?auto=format&fit=crop&w=700&q=80",
];

const stringHash = (value = "") => [...value].reduce((hash, character) => ((hash << 5) - hash) + character.charCodeAt(0), 0);

export const defaultMenuImage = (name) => FREE_MENU_IMAGES[Math.abs(stringHash(name)) % FREE_MENU_IMAGES.length];
